import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 50 50"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "fill-rule": "evenodd" }, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "25",
    cy: "25",
    r: "25"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M20.533 37.613c-.593.054-1.132-.378-1.671-.917-.7-.7-1.402-1.456-2.103-2.156-.808-.81-1.617-1.672-2.426-2.48-.97-.972-1.94-1.995-2.911-2.966-.755-.755-1.51-1.456-2.21-2.264-.648-.755-.648-2.103.215-2.804.97-.809 2.049-.593 2.911.323.647.755 1.348 1.402 2.05 2.103.916.917 1.778 1.833 2.695 2.75.862.863 1.671 1.725 2.534 2.588l.7.7c.163.216.324.27.54 0 .863-.916 1.725-1.725 2.588-2.641.863-.863 1.725-1.78 2.588-2.642a207 207 0 0 0 3.396-3.45c1.079-1.079 2.103-2.211 3.181-3.29l3.074-3.073c.593-.593 1.186-1.24 1.779-1.833.7-.7 1.887-.755 2.588-.108.755.647.809 1.456.647 2.157-.162.539-.485.808-.809 1.132-.809.863-1.617 1.672-2.426 2.48l-2.103 2.103c-.862.863-1.725 1.78-2.588 2.641-1.078 1.079-2.156 2.157-3.18 3.235l-4.368 4.53c-1.078 1.078-2.157 2.21-3.235 3.288-.377.431-.863.594-1.456.594"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }